export const HEARTBEAT_INTERVAL_MS = 60 * 1000
export const INPUT_WINDOW_MS = 90 * 1000

export function shouldSendHeartbeat ({ loggedIn, publicPage, visible, lastInput, now }) {
  return Boolean(loggedIn) && !publicPage && visible && now - lastInput < INPUT_WINDOW_MS
}

export function formatDurata (secondi) {
  const totMin = Math.round((secondi || 0) / 60)
  const h = Math.floor(totMin / 60)
  const m = totMin % 60
  return h === 0 ? `${m}m` : `${h}h ${m}m`
}

const UNITA = [['day', 86400], ['hour', 3600], ['minute', 60]]

export function formatRelativo (data, lang, now = Date.now()) {
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' })
  const diff = Math.round((new Date(data).getTime() - now) / 1000)
  for (const [unita, secondi] of UNITA) {
    if (Math.abs(diff) >= secondi) return rtf.format(Math.trunc(diff / secondi), unita)
  }
  return rtf.format(0, 'second')
}

// oggi, 30 giorni o 12 mesi (dal 1° del mese) fino a oggi, in UTC come il be
export function intervalloPeriodo (granularita, now = new Date()) {
  const da = new Date(now)
  if (granularita === 'giorno') {
    da.setUTCDate(now.getUTCDate() - 29)
  } else if (granularita === 'mese') {
    da.setUTCMonth(da.getUTCMonth() - 11, 1)
  }
  return { da: da.toISOString().slice(0, 10), a: now.toISOString().slice(0, 10) }
}

const pad = n => String(n).padStart(2, '0')

// Etichette leggibili per l'asse X: breve (tick) e estesa (tooltip).
// 'oggi': periodo = ora italiana 0..23 (già convertita dal be)
export function etichettePeriodo (periodo, granularita, lang) {
  const fmt = (d, o) => new Intl.DateTimeFormat(lang, { timeZone: 'UTC', ...o }).format(d)
  if (granularita === 'oggi') {
    return { breve: `${pad(periodo)}:00`, esteso: `${pad(periodo)}:00 – ${pad((periodo + 1) % 24)}:00` }
  }
  if (granularita === 'mese') {
    const d = new Date(`${periodo}-01T00:00:00Z`)
    return { breve: fmt(d, { month: 'short', year: '2-digit' }), esteso: fmt(d, { month: 'long', year: 'numeric' }) }
  }
  const d = new Date(`${periodo}T00:00:00Z`)
  return { breve: fmt(d, { day: 'numeric', month: 'short' }), esteso: fmt(d, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) }
}
